import './index.css'

import React from 'react'
import Text from 'components/ui/text'
type Props = {
  uploading: boolean
  updating: boolean
}

const TrackVersionsOverlay = ({
  uploading,
  updating,
}: Props): null | React.ReactElement<'div'> => {
  let overlayMsg
  if (uploading) overlayMsg = 'Uploading...'
  if (updating) overlayMsg = 'Updating...'
  if (!overlayMsg) return null
  return (
    <div className="ExplorerTrackVersions__Overlay">
      <Text type="paragraph">{overlayMsg}</Text>
    </div>
  )
}

export default TrackVersionsOverlay
